import { ReactNode } from 'react';
import { SimpleSearchFilter } from 'api/dashboard/widget';

export enum ViewType {
  ProjectList = 'PROJECT_LIST',
  ProjectTaskList = 'PROJECT_TASK_LIST',
  AllTasks = 'ALL_TASKS',
  ResourceManagement = 'RESOURCE_MANAGEMENT',
  TimesheetReports = 'TIMESHEET_REPORTS',
  Dashboard = 'DASHBOARD_FILTER',
}

type ViewFilterShareConfigType = {
  sharedWithCustomerPortal: boolean;
  shareWithProjects?: boolean;
  shareWithAllProjects?: boolean;
  filter?: SimpleSearchFilter;
};

export interface View<ViewDefinition> {
  viewId: number;
  viewName: string;
  viewDefinition: ViewDefinition;
  viewIcon?: ReactNode;
  createdBy: number;
  viewType: ViewType;
  self: boolean;
  viewSourceId?: number;
  viewFilterShareConfig?: ViewFilterShareConfigType;
}
